import React from 'react';
import Icon from '../../Icon/index.js';
import { Wrapper, IconBox, Content } from './style.js';

function ToastTemplate(_a) {
  var styleType = _a.styleType,
      content = _a.content,
      options = _a.options,
      theme = _a.theme,
      animation = _a.animation;
  return React.createElement(Wrapper, {
    theme: theme,
    animation: animation,
    options: options
  }, styleType !== 'neutral' && React.createElement(IconBox, {
    options: options
  }, styleType === 'info' && React.createElement(Icon.State, {
    styleType: "info",
    size: "small",
    color: theme.colorTokens.toast.on
  }), styleType === 'success' && React.createElement(Icon.State, {
    styleType: "check",
    size: "small"
  }), styleType === 'error' && React.createElement(Icon.State, {
    styleType: "danger",
    size: "small"
  })), React.createElement(Content, {
    theme: theme,
    styleType: styleType,
    options: options
  }, content));
}

export { ToastTemplate as default };